module.exports = require('../package.json').version;



/*****************
 ** WEBPACK FOOTER
 ** ./~/websocket/lib/version.js
 ** module id = 4170
 ** module chunks = 0
 **/